import React from "react";
import { Space } from "../../components/space/Space";
import { IFilterSelectProps } from "./definitions";
import { useFilterSheets } from "./hooks";
import { useAppDispatch } from "../../app/store/hooks";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";
import Select, { SelectOption } from "@amzn/meridian/select";

export const FilterSelect: React.FC<IFilterSelectProps> = ({ selectOptions }) => {
    const dispatch = useAppDispatch();
    const { filterMap, handleFilterMapUpdate } = useFilterSheets();

    return (
        <Box>
            <Text type={"h100"}> {selectOptions.label}</Text>
            <Space size={"xxs"} />
            <Select
                value={filterMap.get(selectOptions.keyValue)?.value || ""}
                onChange={selectedValue =>
                    dispatch(
                        handleFilterMapUpdate({
                            type: "UPDATE",
                            filterKey: selectOptions.keyValue,
                            filterLabel: selectOptions.label,
                            value: selectedValue,
                        })
                    )
                }
                placeholder={selectOptions.placeholder}
                width={"100%"}
            >
                {selectOptions.options.map(option => {
                    return <SelectOption value={option.value} label={option.label} />;
                })}
            </Select>
        </Box>
    );
};
